module.exports = __webpack_public_path__ + "static/media/S2N11-3.0456165c.svg";